<template>
  <div id="app" class="app">
    <div class="bg">
      <div class="flyout">
        <navbar :color="'lightblue'" class="light-blue darken-4" position="top" dark href="#" scrolling>
          <mdb-navbar-brand href="https://ulkite.ru" style="font-weight: bolder;">
            <span class="logo"><img :src="imgLogoSVG" height="40" alt="ULKite.ru"></span>
            <span class="logo-title">Кайтинг в Ульяновске</span>
          </mdb-navbar-brand>
          <navbar-collapse>
            <navbar-nav right>
              <navbar-item router exact href="/" waves-fixed>Главная</navbar-item>
              <navbar-item router href="/spots/" waves-fixed>Споты</navbar-item>
              <navbar-item router href="/begin/" waves-fixed>Начинающим</navbar-item>
              <navbar-item router href="/contacts/" waves-fixed>Контакты</navbar-item>
            </navbar-nav>
          </navbar-collapse>
        </navbar>
        <main>
          <router-view></router-view>
        </main>
        <Footer color="light-blue darken-4">
          <p class="footer-copyright mb-0 py-3 text-center">
            &copy; {{new Date().getFullYear()}} Copyright: <a href="https://ulkite.ru">ULKite.ru</a>
          </p>
        </Footer>
      </div>
    </div>
  </div>
</template>

<script>
import { Navbar, NavbarItem, NavbarNav, NavbarCollapse, mdbNavbarBrand, Footer } from 'mdbvue'
import imgBg from './assets/bg/bg-2.jpg'
import imgLogoSVG from './assets/logo/logo.svg'

export default {
  name: 'app',
  components: {
    Navbar,
    NavbarItem,
    NavbarNav,
    NavbarCollapse,
    mdbNavbarBrand,
    Footer
  },
  data: function () {
    return {
      imgBg: imgBg,
      imgLogoSVG: imgLogoSVG
    }
  },
  mounted () {
    // You'll need this for renderAfterDocumentEvent.
    document.dispatchEvent(new Event('render-event'))
  }
}
</script>

<style>
  .navbar-brand {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-right: 0 !important;
  }
  .navbar-brand .logo {
    padding-right: 16px;
  }
  @media (max-width: 320px) {
    .navbar-brand .logo-title {
      display:none;
    }
  }

  body,html,app {
    height: 100%;
  }
  .bg-logo {
    width: 320px;
    height: 320px;
    position: absolute;
    left: calc(50% - 160px);
    top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue